export default __webpack_public_path__ + "static/media/home-cafe-img-03.832b4e1b.jpg";